export const FIXED_WORKING_HOURS_MODE = 0
export const FLEXIBLE_WORKING_HOURS_MODE = 1
export const FLEXIBLE_SCHEDULE_DAY = 7
